/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DailyOrgSummaryUsageResponse } from './dailyOrgSummaryUsageResponse';


export interface DailyOrgSummaryBulkResponse { 
    daily_org_summary_usages?: Array<DailyOrgSummaryUsageResponse>;
    total_record_count?: number;
}

